import AppLayout from "../layout/AppLayout";
import { useLocation } from "react-router-dom";
import { Row, Col } from "antd";
import DynamicFormWizard from "./wizard/DynamicFormWizard";
import pic from "../../assets/img/CHUTTE_1.JPG";

const Results = () => {
  const location = useLocation();
  const description = location.state?.description || {};
  const pageToNavigate = location.state?.pageToNavigate || "";
  const responseData = location.state.responseData || {};

  return (
    <AppLayout>
      <Row gutter={[12, 12]}>
      <Col xs={24} md={12} lg={12}>
          <DynamicFormWizard apiData={description} pageToNavigate={pageToNavigate} responseData={responseData}  />
        </Col>
        <Col xs={24} md={12} lg={12}>
          <img
            src={pic}
            alt="Transportation"
            className="bounce-in"
            style={{ width: "100%", height: "80vh", borderRadius: 10 }}
          />
        </Col>
      </Row>
    </AppLayout>
  );
};

export default Results;
